// SEO Mapping - 39 URLs avec titles et descriptions uniques
// BASE_DESCRIPTION identique partout

const BASE_DESCRIPTION = "DIAGNOSTICS DPE IMMOBILIER HAUTE-LOIRE/LOZERE – Tél: 04.71.08.27.09.";

const seoMap = {
  "/": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Haute-Loire & Lozère | CPPB",
    description: `${BASE_DESCRIPTION} DPE vente/location, amiante, plomb, gaz, électricité, ERP, Carrez, audit. Intervention 24-48h.`
  },
  "/diagnostics": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Liste des diagnostics | CPPB",
    description: `${BASE_DESCRIPTION} Tous les diagnostics obligatoires vente/location : DPE, amiante, plomb, gaz, électricité, ERP, Carrez, termites, assainissement.`
  },
  "/contact": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Devis & Contact | CPPB",
    description: `${BASE_DESCRIPTION} Devis gratuit rapide. Intervention 24-48h en Haute-Loire (43) et Lozère (48). Téléphone, email et formulaire.`
  },
  "/diagnostics/diagnostic-performance-energetique-dpe": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – DPE (performance énergétique) | CPPB",
    description: `${BASE_DESCRIPTION} DPE obligatoire pour vente/location. Étiquette énergie et GES, conseils et rapport sous 72h. RDV rapide.`
  },
  "/diagnostics/diagnostic-amiante": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Diagnostic Amiante | CPPB",
    description: `${BASE_DESCRIPTION} Amiante avant vente/travaux : repérage matériaux, obligations, validité, résultats clairs. Intervention 24-48h.`
  },
  "/diagnostics/diagnostic-plomb-crep": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Diagnostic Plomb (CREP) | CPPB",
    description: `${BASE_DESCRIPTION} CREP plomb avant 1949 : contrôle, seuils, rapport et recommandations. RDV rapide 43/48.`
  },
  "/diagnostics/diagnostic-gaz": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Diagnostic Gaz | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostic gaz installations +15 ans : anomalies, sécurité, rapport complet. Intervention rapide Haute-Loire/Lozère.`
  },
  "/diagnostics/diagnostic-electricite": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Diagnostic Électricité | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostic électricité +15 ans : sécurité, points de contrôle, rapport clair pour vente/location. RDV 24-48h.`
  },
  "/diagnostics/diagnostic-termites": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Diagnostic Termites | CPPB",
    description: `${BASE_DESCRIPTION} Termites / insectes xylophages : recherche, zones, obligations et rapport. Intervention rapide 43/48.`
  },
  "/diagnostics/loi-carrez-mesurage": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Mesurage Loi Carrez | CPPB",
    description: `${BASE_DESCRIPTION} Mesurage Carrez en copropriété : surface privative, attestation et remise rapide. Devis gratuit.`
  },
  "/diagnostics/etat-risques-pollutions-erp": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – ERP (État des risques) | CPPB",
    description: `${BASE_DESCRIPTION} ERP : risques naturels/miniers/technologiques, radon, informations obligatoires vente/location. Livraison rapide.`
  },
  "/diagnostics/diagnostic-assainissement": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Assainissement | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostic assainissement non collectif : contrôle, conformité et rapport. Intervention rapide Haute-Loire/Lozère.`
  },
  "/diagnostics/audit-energetique": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Audit énergétique | CPPB",
    description: `${BASE_DESCRIPTION} Audit énergétique : scénarios de travaux, priorités, estimations et plan d'amélioration. RDV rapide 43/48.`
  },
  "/expertise": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Expertise & méthode | CPPB",
    description: `${BASE_DESCRIPTION} Méthode d'intervention, délais, qualité du rapport et accompagnement. Diagnostic immobilier sérieux en 43/48.`
  },
  "/validite": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Durées de validité | CPPB",
    description: `${BASE_DESCRIPTION} Durées de validité des diagnostics : DPE, amiante, plomb, gaz, électricité, ERP, Carrez. Tableau clair.`
  },
  "/avis": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Avis clients | CPPB",
    description: `${BASE_DESCRIPTION} Avis clients et retours d'expérience. Intervention 24-48h, rapports rapides, devis gratuit en Haute-Loire/Lozère.`
  },
  "/actualites-diagnostics": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Actualités diagnostics | CPPB",
    description: `${BASE_DESCRIPTION} Veille réglementaire DPE et diagnostics : obligations, mises à jour, points clés vente/location. News mises à jour.`
  },
  // Pages villes Haute-Loire (43)
  "/diagnostic-immobilier-le-puy-en-velay-43000": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Le Puy-en-Velay (43000) | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostics au Puy-en-Velay : DPE, amiante, plomb, gaz, électricité, ERP. RDV rapide 24-48h.`
  },
  "/diagnostic-immobilier-yssingeaux-43200": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Yssingeaux (43200) | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostics à Yssingeaux : DPE et diagnostics vente/location. Intervention rapide, devis gratuit.`
  },
  "/diagnostic-immobilier-brioude-43100": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Brioude (43100) | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostics à Brioude : DPE, amiante, plomb, gaz, électricité, ERP, Carrez. RDV 24-48h.`
  },
  "/diagnostic-immobilier-monistrol-sur-loire-43120": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Monistrol-sur-Loire (43120) | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostics à Monistrol-sur-Loire : vente/location, rapports rapides, devis gratuit. DPE et plus.`
  },
  "/diagnostic-immobilier-rauret-43340": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Rauret (43340) | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostics à Rauret : DPE, amiante, plomb, gaz, électricité, ERP. Intervention rapide 43/48.`
  },
  "/diagnostic-immobilier-sainte-sigolene-43600": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Sainte-Sigolène (43600) | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostics à Sainte-Sigolène : DPE vente/location, gaz, électricité, ERP, Carrez. RDV 24-48h.`
  },
  "/diagnostic-immobilier-aurec-sur-loire-43110": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Aurec-sur-Loire (43110) | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostics à Aurec-sur-Loire : DPE, amiante, plomb, gaz, électricité. Devis gratuit, rapide.`
  },
  "/diagnostic-immobilier-langeac-43300": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Langeac (43300) | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostics à Langeac : obligations vente/location, rapports sous 72h. DPE + diagnostics complets.`
  },
  "/diagnostic-immobilier-craponne-sur-arzon-43500": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Craponne-sur-Arzon (43500) | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostics à Craponne-sur-Arzon : DPE, amiante, plomb, gaz, électricité, ERP. RDV rapide.`
  },
  "/diagnostic-immobilier-retournac-43130": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Retournac (43130) | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostics à Retournac : vente/location, DPE et contrôles gaz/électricité. Intervention 24-48h.`
  },
  "/diagnostic-immobilier-saugues-43170": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Saugues (43170) | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostics à Saugues : DPE, amiante, plomb, ERP, Carrez. Devis gratuit, rapport rapide.`
  },
  "/diagnostic-immobilier-pradelles-43420": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Pradelles (43420) | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostics à Pradelles : diagnostics obligatoires vente/location. DPE et pack diagnostics complet.`
  },
  "/diagnostic-immobilier-cayres-43510": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Cayres (43510) | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostics à Cayres : DPE, gaz, électricité, ERP, Carrez. RDV rapide en Haute-Loire.`
  },
  // Pages villes Lozère (48)
  "/diagnostic-immobilier-langogne-48300": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Langogne (48300) | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostics à Langogne : DPE, amiante, plomb, gaz, électricité, ERP. Intervention rapide Lozère.`
  },
  "/diagnostic-immobilier-auroux-48600": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Auroux (48600) | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostics à Auroux : vente/location, DPE et contrôles gaz/électricité. Devis gratuit 48.`
  },
  "/diagnostic-immobilier-chaudeyrac-48170": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Chaudeyrac (48170) | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostics à Chaudeyrac : DPE, amiante, plomb, ERP. Intervention rapide en Lozère.`
  },
  "/diagnostic-immobilier-grandrieu-48600": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Grandrieu (48600) | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostics à Grandrieu : DPE et diagnostics obligatoires vente/location. RDV 24-48h.`
  },
  "/diagnostic-immobilier-la-bastide-puylaurent-48250": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – La Bastide-Puylaurent (48250) | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostics à La Bastide-Puylaurent : DPE, gaz, électricité, ERP, Carrez. Devis gratuit.`
  },
  "/diagnostic-immobilier-chateauneuf-de-randon-48170": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Châteauneuf-de-Randon (48170) | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostics à Châteauneuf-de-Randon : DPE, amiante, plomb, ERP. Intervention rapide 48.`
  },
  "/diagnostic-immobilier-le-malzieu-ville-48140": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Le Malzieu-Ville (48140) | CPPB",
    description: `${BASE_DESCRIPTION} Diagnostics au Malzieu-Ville : DPE vente/location, gaz, électricité, ERP. RDV rapide en Lozère.`
  },
  // Pages légales
  "/mentions-legales": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Mentions légales | CPPB",
    description: `${BASE_DESCRIPTION} Mentions légales CPPB : identité, activité, hébergement, contact et informations réglementaires du site.`
  },
  "/politique-confidentialite": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Confidentialité | CPPB",
    description: `${BASE_DESCRIPTION} Politique de confidentialité : données, cookies, finalités, durée de conservation et droits RGPD.`
  },
  // Alias actualités
  "/actualites": {
    title: "DIAGNOSTICS IMMOBILIER DPE 43/48 – Actualités | CPPB",
    description: `${BASE_DESCRIPTION} Actualités et veille réglementaire diagnostics immobiliers. Informations DPE, obligations 2025.`
  }
};

export default seoMap;
